<app-loader></app-loader>
<div class="driver-success-model">
    <img src="../../../../assets/images/driver-success.png" alt="Driver Success" />
    <h4> Payment Paid - ${{totalAmount}}</h4>
    <p [innerHTML]="bodyText"></p>
    <div class="btn-outer">
        <p-button label="Yes" (onClick)="onconfirm()" />
        <p-button styleClass="p-button p-button-outlined" label="No" (onClick)="closeDialog()" />
    </div>
</div>